import { FormGroup, FormGroupDirective } from '@angular/forms'
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap'

export function deepCopy(obj: any): any {
    return structuredClone(obj)
}

export function scrollToTop() {
    window.scroll({
        top: 0,
        behavior: 'smooth',
    })
}

export function formatDateForBack(date: Date): string {
    const year = date.getFullYear().toString()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')
    const seconds = date.getSeconds().toString().padStart(2, '0')

    return year + month + day + hours + minutes + seconds
}

export function formatDateStructForBack(date: NgbDateStruct): string {
    const year = date.year.toString()
    const month = date.month.toString().padStart(2, '0')
    const day = date.day.toString().padStart(2, '0')
    const hours = '00'
    const minutes = '00'
    const seconds = '00'

    return year + month + day + hours + minutes + seconds
}

export function formatDateFromBack(dateString: string) {
    const year = parseInt(dateString.substring(0, 4), 10)
    const month = parseInt(dateString.substring(4, 6), 10) - 1
    const day = parseInt(dateString.substring(6, 8), 10)
    const hours = parseInt(dateString.substring(8, 10), 10)
    const minutes = parseInt(dateString.substring(10, 12), 10)
    const seconds = parseInt(dateString.substring(12, 14), 10)

    if (isNaN(year) || isNaN(month) || isNaN(day) || isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
        return '-'
    }

    const date = new Date(year, month, day, hours, minutes, seconds)
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
}

export function shouldDisplayInvalid(form: FormGroup, formElement: FormGroupDirective, fieldName: string) {
    return form.get(fieldName).invalid && (form.get(fieldName).touched || formElement.submitted)
}

export function lancementIsValid(lancement: string): boolean {
    return lancement === 'Validé' || lancement === 'Demande Manuelle'
}

export function compareRawDates(rawDateA: string | undefined, rawDateB: string | undefined): number {
    const dateA = rawDateA ? Number(rawDateA) : 0
    const dateB = rawDateB ? Number(rawDateB) : 0
    return dateA - dateB
}

export function compareNullableNumbers(valA: number | null | undefined, valB: number | null | undefined): number {
    const numA = (valA === null || valA === undefined) ? -Infinity : valA
    const numB = (valB === null || valB === undefined) ? -Infinity : valB
    return numA - numB
}
